import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { PageConfig } from '../../../models/configs/page-config';
import { DecoratorService } from '../../../decoration-base/decorator.service';
import { SIDE_BAR_KEY } from '../../../decorators/sidebar-nav-menu-item';
import { SharedDataService } from '../../../services/shared-data.service';
import { LoginEntityService } from '../../../services/entity-services/login-entity.service';
import { Log, IShortLogger } from '../../../services/logger.service';
import { NotificationsService } from '../../../services/home-services/notifications.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css'
})
export class SidebarComponent implements OnInit, OnDestroy {
  private readonly logger: IShortLogger<SidebarComponent> = Log.create(SidebarComponent);

  @Input() collapsed = false;
  @Output() toggleSidebar = new EventEmitter<void>();

  public pages: PageConfig[] = [];
  public unreadCount = 0;

  selectedMenu: string = '';
  businessProcesses: any[] = [];

  private notifSubscription = new Subscription();

  constructor(private decorationService: DecoratorService,
    private sharedService: SharedDataService,
    private loginEntityService: LoginEntityService,
    private notificationsService: NotificationsService
  ) { }

  ngOnInit(): void {
    this.getAllConfigs();
    this.sharedService.selectedMenu$.subscribe(menu => {
      this.selectedMenu = menu;
    });
    this.notifSubscription = this.notificationsService.unreadCount$
      .subscribe(count => { this.unreadCount = count; });
  }

  ngOnDestroy(): void {
    this.notifSubscription.unsubscribe();
  }

  sanitizeRoute(route: string): string {
    if (!route.startsWith('/')) {
      route = `/${route}`;
    }
    return route.trim();
  }

  /*
  getAllConfigs() {
    var loginUser = localStorage.getItem("userName");
    this.pages = this.decorationService
      .getDecoratedComponents(SIDE_BAR_KEY)
      .map(component =>
        this.decorationService.getComponentConfig<PageConfig>(component, SIDE_BAR_KEY)
      ).filter(config => config !== undefined && (config.roles == undefined || config.roles.length == 0
        || config.roles.find(r => r == loginUser))) as PageConfig[];

    this.pages = this.pages.sort((a, b) => a.order - b.order);

  }
    */
  getAllConfigs() {
    var userRoles = localStorage.getItem("roles");
    var userRolesArray: string[] = [];
    var userId = localStorage.getItem("userId");

    this.logger.i("getAllConfigs called - userId from localStorage:", userId);
    this.logger.i("getAllConfigs called - userRoles from localStorage:", userRoles);

    // Parse the roles string array from localStorage
    if (userRoles) {
      try {
        userRolesArray = JSON.parse(userRoles);
      } catch (error) {
        this.logger.e("Error parsing roles from localStorage:", error);
        userRolesArray = [];
      }
    }

    if (userId) {
      this.logger.i("Calling getBusinessProcessesByUserId for userId:", userId);
      this.loginEntityService.getBusinessProcessesByUserId(userId).subscribe(businessProcesses => {

        this.logger.i("Received business processes:", businessProcesses);



        this.pages = this.decorationService
          .getDecoratedComponents(SIDE_BAR_KEY)
          .map(component =>
            this.decorationService.getComponentConfig<PageConfig>(component, SIDE_BAR_KEY)
          ).filter(config => config !== undefined && (

            businessProcesses.some((bp: { name: string | undefined; }) => bp.name === config.businessProcessesName)
          )) as PageConfig[];


        this.pages.forEach(page => {
          var bp = businessProcesses.find((bp: { name: string | undefined; }) => bp.name === page.businessProcessesName);
          page.displayName = bp && bp.displayName ? bp.displayName : page.name;
          page.order = bp && bp.srno ? bp.srno : page.order;
        });

        this.pages = this.pages.sort((a, b) => a.order - b.order);

        this.logger.i("Final filtered pages count:", this.pages.length);
        this.logger.i("Final filtered pages:", this.pages);

        // Handle the business processes data
      });
    } else {
      this.logger.w("No userId found in localStorage.");
    }



  }


  onMenuClick(menuName: string): void {
    // Update the selected menu in the shared service
    // this.sharedService.updateSelectedMenu(menuName);
  }

  getMaterialIcon(faIcon: string): string {
    // Icons are now stored as Material icon names directly in the decorator.
    // Normalize any legacy fa- prefixed stragglers and return as-is.
    return (faIcon ?? 'category').trim().replace(/^(fas?|far|fal)\s+fa-/, '').replace(/^fa-/, '') || 'category';
  }
}
